import { actions } from './reducer'
import api from 'lib/api/docServiceApi'
import { formatError } from 'utils/formatError'

const clearDocumentUrl = () => {
  return async dispatch => {
    dispatch(actions.clearDocumentUrl())
  }
}

const clearErrors = () => {
  return async dispatch => {
    dispatch(actions.clearErrors())
  }
}

const fetchDocumentUrl = args => {
  return async dispatch => {
    dispatch(actions.fetchingDocumentUrl())
    try {
      const options = {
        useFlexTemplate: true,
        useHsFullTemplate: true,
      }
      const response = await api.fetchDocumentUrl({ ...args, options })
      dispatch(actions.fetchingDocumentUrlSuccess(response))
    } catch (error) {
      dispatch(actions.fetchingDocumentUrlError(formatError(error)))
    }
  }
}

export default {
  clearDocumentUrl,
  clearErrors,
  fetchDocumentUrl,
}
